<template>
  <div id="skeleton-loader" class="loading-skeleton">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'skeleton-loader'
}
</script>